import React from "react";

export const Badge = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="cw-rounded-full cw-bg-busy-inset-pressed cw-flex cw-items-center cw-justify-center cw-px-2 cw-py-1 cw-w-4 cw-basis-[16px]">
      <div className="cw-text-onEmphasis cw-text-[8px]">{children}</div>
    </div>
  );
};
